import React from "react";
import { FormListFieldData } from "antd";
import { SmlJsonQuery, SmlJsonQueryFilter, SmlJsonQueryOrder } from "@src/types/intelligence-search";
import { SearchComponentMemo } from "@src/pages/intelligence-search-v2/components/json-query/search-component";
import { ChartWrapperContextProvider } from "@src/contexts/ab-testing/chart-wrapper-context";
import dayjs from "dayjs";
import { FormInstance } from "antd/lib";

export type JsonQueryBuilderConfig = {
    selected_assets_or_filters?: (string | SmlJsonQueryFilter)[];
    orders?: SmlJsonQueryOrder[];
    limit?: number;
    timeRange?: dayjs.Dayjs[];
};

type JsonQueryBuilderProps = {
    queryKey: string;
    value?: JsonQueryBuilderConfig;
    onChange?: (jsonQuery: SmlJsonQuery, builderConfig: JsonQueryBuilderConfig) => void;
    productCode?: string;
    platform?: string[];
    timeRange: dayjs.Dayjs[];
    form: FormInstance;
    formListFieldData: FormListFieldData;
};

const JsonQueryBuilder: React.FC<JsonQueryBuilderProps> = ({
    queryKey,
    value,
    onChange,
    productCode,
    platform,
    timeRange,
    form,
    formListFieldData,
}) => {
    const handleChange = (q: SmlJsonQuery, cfg: JsonQueryBuilderConfig) => {
        if (onChange) {
            onChange(q, cfg);
        }
    };

    return (
        <ChartWrapperContextProvider>
            <div className="w-full ">
                <SearchComponentMemo
                    value={value}
                    queryKey={queryKey}
                    form={form}
                    onChange={(jsonQuery: SmlJsonQuery, builderConfig: JsonQueryBuilderConfig) => {
                        handleChange(jsonQuery, builderConfig);
                    }}
                    formListFieldData={formListFieldData}
                    platform={platform}
                    productCode={productCode}
                    timeRange={timeRange}
                />
            </div>
        </ChartWrapperContextProvider>
    );
};

export const JsonQueryBuilderMemo = React.memo(JsonQueryBuilder, (prev, next) => {
    const { onChange: _1, form: _2, ...restPrev } = prev;
    const { onChange: _3, form: _4, ...restNext } = next;
    // console.log("JsonQueryBuilder ", restPrev.formListFieldData.name, { restPrev, restNext });

    return JSON.stringify(restPrev) === JSON.stringify(restNext);
});
